export const randomId = () => {
    const rNumber = Math.random();
    const rString = rNumber.toString().slice(2, 8);
    return `d-${rString}`;
};
